import { render, staticRenderFns } from "./invoice-content-detail.vue?vue&type=template&id=60ad4b2e&scoped=true&"
import script from "./invoice-content-detail.vue?vue&type=script&lang=js&"
export * from "./invoice-content-detail.vue?vue&type=script&lang=js&"
import style0 from "./invoice-content-detail.vue?vue&type=style&index=0&id=60ad4b2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ad4b2e",
  null
  
)

export default component.exports